const functions = {
    availableMethods() {
        return [
            'getAll',
            'getOne',
            'updateOne',
            'createOne',
            'deleteOne'
        ];
    }

};

export default functions;
